import React, { useState, useMemo } from "react";
import { Drawer, Button, Typography, Collapse, message } from "antd";
import {
  MinusOutlined,
  PlusOutlined,
  StarOutlined,
  DeleteOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { axiosInstance } from "../utils/axiosInterceptor";
import { useSelector } from "react-redux";

const { Text } = Typography;
const { Panel } = Collapse;

const CartDrawer = ({
  visible,
  onClose,
  selectedProducts,
  setSelectedProducts,
  getCartData,
  getCatalogueDetails,
pageSize,
currentPage
}) => {
  const [favorites, setFavorites] = useState({});
  const [isLoading,setIsLoading] = useState(false)
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);

  const groupedProducts = useMemo(() => {
    return selectedProducts.reduce((acc, product) => {
      const supplier = product?.supplier_name || "AAFA";
      if (!acc[supplier]) acc[supplier] = [];
      acc[supplier].push(product);
      return acc;
    }, {});
  }, [selectedProducts]);

  const totalCost = selectedProducts?.reduce(
    (sum, p) => sum + p.unit_price * p.quantity,
    0
  );

  const totalSavings = 0;

  const handleQuantityChange = (productCode, newQty, maxQty) => {
    if (newQty < 1) return;

    if (newQty > maxQty) return;

    setSelectedProducts((prev) =>
      prev.map((p) =>
        p.product_code === productCode ? { ...p, quantity: newQty } : p
      )
    );
  };

  const handleRemoveFromCart = async (productCode) => {
    const payload = {
      userId: userAuth?.id,
      product_code: productCode,
    };
    try {
      const response = await axiosInstance.post(
        "marketplace/cart/remove",
        payload
      );
      getCartData();
    } catch (error) {
      console.log(error, "Errrorr");
    }
  };

  const toggleFavorite = (productCode) => {
    setFavorites((prev) => ({
      ...prev,
      [productCode]: !prev[productCode],
    }));
  };

  const CustomPanelHeader = ({ supplier, products }) => (
    <div className="flex items-center justify-between w-full ">
      <div className="flex items-center gap-2">
        {/* <span className="text-blue-600">⊕</span> */}
        <Text strong>{supplier}</Text>
      </div>
      <Text type="secondary" className="text-sm">
        {products?.length} items
      </Text>
    </div>
  );
  const CheckOut = async()=>{
    setIsLoading(true)
    const payload = {
      userId:userAuth?.id,
      customer_name:userAuth?.first_name
    }
    try {
      const response  = await axiosInstance.post('marketplace/cart/checkout',payload);
      // console.log(response,"Reposneee")
      onClose()
      message.success(`${response?.data?.message} `)
      getCatalogueDetails(currentPage,pageSize)
    } catch (error) {
      console.log(error,"Error")
      message.error(error?.response?.data?.message)
    }
    finally{
      setIsLoading(false)
    }
  }

  return (
    <Drawer
      title={
        <div className="flex items-center justify-between p-2 border-none">
          <span className="text-[18px] font-bold text-[#0b1c4d]">Quick Cart</span>
          <div
      onClick={onClose}
      className="w-[30px] h-[30px] flex items-center justify-center rounded-lg bg-[#eef2ff] cursor-pointer hover:bg-[#e0e7ff]"
    >
      <CloseOutlined className="text-[#0b1c4d] text-[18px]" />
    </div>

        </div>
      }
      placement="right"
      onClose={onClose}
      closable={false}
      open={visible}
      width={400}
      bodyStyle={{ padding: 0 }}
      footer={
        <div className="px-4 py-3">
          <div className="flex justify-between text-sm mb-2">
            <Text type="secondary">Total savings</Text>
            <Text type="primary">
               $ {Number(
                      totalSavings || 0
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
            </Text>
          </div>
          <div className="flex justify-between mb-4">
            <Text strong className="text-[20px] font-bold">Total cost</Text>
            <Text strong className="text-[20px] font-bold">
               $ {Number(
                      totalCost || 0
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
            </Text>
          </div>
          <Button
            // type="primary"
            block
            // style={{
            //   backgroundColor: "#4F46E5",
            //   height: "40px",
            //   color:"#fff"
            // }}
            className="!bg-[#001997] hover:!bg-[#061561] text-white border-none hover:!text-white disabled:!bg-[#001997] disabled:!text-white"
            disabled={selectedProducts?.length === 0}
            loading={isLoading}
            onClick={()=>CheckOut()}
          >
            Continue Purchasing
          </Button>
        </div>
      }
    >
      <div className="flex flex-col mt-4 mb-4 ml-2 mr-2">
        <Collapse
           defaultActiveKey={Object.keys(groupedProducts)}
           ghost
           expandIconPosition="end" 
         >
           {Object.entries(groupedProducts).map(([supplier, products]) => (
             <Panel
               key={supplier}
               header={
                 <CustomPanelHeader supplier={supplier} products={products} />
               }
             >
        {products?.map((product) => (
          <div key={product.product_code} className="mb-6 px-4">
            <div className="flex justify-between items-center">
              <div>
                <Text
                  className="block mb-1 text-[#222]"
                  style={{ fontSize: 14, fontWeight: "500" }}
                >
                  {product.product_name}
                </Text>
              </div>
              <div>
                <Button
                  type="text"
                  icon={
                    <StarOutlined
                      className={
                        favorites[product.product_code]
                          ? "text-yellow-400"
                          : "text-gray-400"
                      }
                    />
                  }
                  size="small"
                  onClick={() => toggleFavorite(product.product_code)}
                />
                <Button
                  type="text"
                  icon={<DeleteOutlined className="text-red-600" />}
                  size="small"
                  onClick={() => handleRemoveFromCart(product.product_code)}
                />
              </div>
            </div>
            <div className="flex items-center justify-between">
              {/* <div className="flex items-center gap-2 ">
                       <Button
                         icon={<MinusOutlined />}
                         size="small"
                         type="text"
                         style={{
                           border: "1px solid #d9d9d9",
                           padding: "0 4px",
                         }}
                        //  onClick={() =>
                        //    handleQuantityChange(
                        //      product.product_code,
                        //      product.quantity - 1
                        //    )
                        //  }
                       />
                       <span className="min-w-[2rem] text-center">
                         {product.quantity}
                       </span>
                       <Button
                         icon={<PlusOutlined />}
                         size="small"
                         type="text"
                         style={{
                           border: "1px solid #d9d9d9",
                           padding: "0 4px",
                         }}
                        //  onClick={() =>
                        //    handleQuantityChange(
                        //      product.product_code,
                        //      product.quantity + 1
                        //    )
                        //  }
                       />
                     </div> */}
              <div className="flex items-center border border-[#d0d7e2] rounded-[6px] overflow-hidden bg-white">
                <div
                  // onClick={() => handleQuantityChange(product.product_code, product.quantity - 1)}
                  className="w-[36px] h-[32px] flex items-center justify-center cursor-pointer select-none border-r border-[#d0d7e2] text-[#4a4a4a]"
                >
                  −
                </div>

                <div className="w-[44px] h-[32px] flex items-center justify-center border-r border-[#d0d7e2] text-[#4a4a4a] text-sm">
                  {product.quantity}
                </div>

                <div
                  // onClick={() => handleQuantityChange(product.product_code, product.quantity + 1)}
                  className="w-[36px] h-[32px] flex items-center justify-center cursor-pointer select-none text-[#4a4a4a]"
                >
                  +
                </div>
              </div>

              <div className="flex items-center gap-3">
                <Text strong>
                  $ {Number(
                      product.unit_price * product.quantity
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  {/* $ {(product.unit_price * product.quantity).toFixed(2)} */}
                </Text>
              </div>
            </div>
          </div>
        ))}
        </Panel>
           ))}
         </Collapse>
      </div>
    </Drawer>
  );
};

export default CartDrawer;

// import React, { useState } from "react";
// import { Drawer, Button, Typography, Collapse } from "antd";
// import {
//   DownOutlined,
//   MinusOutlined,
//   PlusOutlined,
//   StarOutlined,
//   MoreOutlined,
//   DeleteOutlined,
// } from "@ant-design/icons";

// const { Text } = Typography;
// const { Panel } = Collapse;

// const CartDrawer = ({
//   visible,
//   onClose,
//   selectedProducts,
//   setSelectedProducts,
// }) => {
//   // Group products by supplier
//   const groupedProducts = selectedProducts.reduce((acc, product) => {
//     if (!acc[product.supplier]) {
//       acc[product.supplier] = [];
//     }
//     acc[product.supplier].push(product);
//     return acc;
//   }, {});

//   // Calculate totals
//   const totalCost = selectedProducts.reduce(
//     (sum, product) => sum + product.price * product.purchaseQty,
//     0
//   );
//   const totalSavings = -200; // Mock savings value

//   // Handle quantity changes
//   const handleQuantityChange = (productId, newQty) => {
//     setSelectedProducts((prevProducts) =>
//       prevProducts.map((product) =>
//         product.id === productId
//           ? { ...product, purchaseQty: Math.max(0, newQty) }
//           : product
//       )
//     );
//   };

//   // Handle removing item from cart
//   const handleRemoveFromCart = (productId) => {
//     setSelectedProducts((prevProducts) =>
//       prevProducts.filter((product) => product.id !== productId)
//     );
//   };

//   // Handle favorite toggle
//   const [favorites, setFavorites] = useState({});
//   const toggleFavorite = (productId) => {
//     setFavorites((prev) => ({
//       ...prev,
//       [productId]: !prev[productId],
//     }));
//   };

//   // Custom header for collapse panel
//   const CustomPanelHeader = ({ supplier, products }) => (
//     <div className="flex items-center justify-between w-full">
//       <div className="flex items-center gap-2">
//         <span className="text-blue-600">⊕</span>
//         <Text strong>{supplier}</Text>
//       </div>
//       <Text type="secondary" className="text-sm">
//         {products.length} items
//       </Text>
//     </div>
//   );

//   return (
//     <Drawer
//       title="Quick Cart"
//       placement="right"
//       onClose={onClose}
//       open={visible}
//       width={400}
//       bodyStyle={{ padding: 0 }}
//       footer={
//         <div className="px-4 py-3">
//           <div className="flex justify-between text-sm mb-2">
//             <Text type="secondary">Total savings</Text>
//             <Text type="danger">${totalSavings.toFixed(2)}</Text>
//           </div>
//           <div className="flex justify-between mb-4">
//             <Text strong>Total cost</Text>
//             <Text strong>${totalCost.toFixed(2)}</Text>
//           </div>
//           <Button
//             type="primary"
//             block
//             style={{
//               backgroundColor: "#4F46E5",
//               height: "40px",
//             }}
//           >
//             Continue Purchasing
//           </Button>
//         </div>
//       }
//     >
//       <div className="flex flex-col">
//         <Collapse
//           defaultActiveKey={Object.keys(groupedProducts)}
//           ghost
//           expandIconPosition="end"
//         >
//           {Object.entries(groupedProducts).map(([supplier, products]) => (
//             <Panel
//               key={supplier}
//               header={
//                 <CustomPanelHeader supplier={supplier} products={products} />
//               }
//             >
//               {products.map((product) => (
//                 <div key={product.id} className="mb-4 px-4">
//                   <Text className="block mb-1">{product.description}</Text>
//                   <div className="flex items-center justify-between">
//                     <div className="flex items-center gap-2">
//                       <Button
//                         icon={<MinusOutlined />}
//                         size="small"
//                         type="text"
//                         style={{
//                           border: "1px solid #d9d9d9",
//                           padding: "0 4px",
//                         }}
//                         onClick={() =>
//                           handleQuantityChange(
//                             product.id,
//                             product.purchaseQty - 1
//                           )
//                         }
//                       />
//                       <span className="min-w-[2rem] text-center">
//                         {product.purchaseQty}
//                       </span>
//                       <Button
//                         icon={<PlusOutlined />}
//                         size="small"
//                         type="text"
//                         style={{
//                           border: "1px solid #d9d9d9",
//                           padding: "0 4px",
//                         }}
//                         onClick={() =>
//                           handleQuantityChange(
//                             product.id,
//                             product.purchaseQty + 1
//                           )
//                         }
//                       />
//                     </div>
//                     <div className="flex items-center gap-3">
//                       <Button
//                         type="text"
//                         icon={
//                           <StarOutlined
//                             className={
//                               favorites[product.id]
//                                 ? "text-yellow-400"
//                                 : "text-gray-400"
//                             }
//                           />
//                         }
//                         size="small"
//                         onClick={() => toggleFavorite(product.id)}
//                       />
//                       <Button
//                         type="text"
//                         icon={<DeleteOutlined className="text-gray-400" />}
//                         size="small"
//                         onClick={() => handleRemoveFromCart(product.id)}
//                       />
//                       <Text strong>${product.price.toFixed(2)}</Text>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </Panel>
//           ))}
//         </Collapse>
//       </div>
//     </Drawer>
//   );
// };

// export default CartDrawer;
